import React, { Component } from 'react';
import { Collapse, Button, CardBody, Card, CardHeader } from 'reactstrap';
import LoaderSpinner from '../views/Widgets/LoaderSpinner';
import GNAddressFormat from '../helpers/GNAddressFormat';
import parseDate from '../helpers/parseDate';
import NumberFormat from 'react-number-format';

export default class DropdownCard extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.onDeny = this.onDeny.bind(this);
    this.onApprove = this.onApprove.bind(this);
    this.onArchive = this.onArchive.bind(this);
    this.state = {
      collapse: false,
      isDenying: false,
      isApproving: false,
      claimStatusTitleText: '',
      claimStatusTitleTextColor: '#000',
    };
  }

  componentDidMount() {
    if (this.props.data.data.note.indexOf('ADD BUSINESS') !== -1)
      this.setState({
        claimStatusTitleText: '   (New Business)',
        claimStatusTitleTextColor: '#26BA5F',
      });
    else if (this.props.data.data.note.indexOf('CLAIM BUSINESS') !== -1)
      this.setState({
        claimStatusTitleText: '   (Claimed Business)',
        claimStatusTitleTextColor: '#20BED6',
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.finishedWithError) {
      this.setState({
        isDenying: false,
        isApproving: false,
        isArchiving: false,
      });
    }
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse }, () => {
      if (this.props.onOpen && this.state.collapse) {
        this.props.onOpen();
      }
    });
  }

  onApprove() {
    this.setState({ isApproving: true });
    this.props.onApprove();
  }

  onDeny() {
    this.setState({ isDenying: true });
    this.props.onDeny();
  }

  onArchive() {
    this.setState({ isArchiving: true });
    this.props.onArchive();
  }

  render() {
    let { email, note, phone, permissionGroup } = this.props.data.data;

    if (note.includes('User Note')) {
      note = note.split('User Note:')[1];
      note = note.split('User System Email:')[0];
    } else note = note;
    // root claim data
    const { id: claimID, date } = this.props.data;

    // business data
    const {
      id: businessID,
      name: businessName,
      slug,
      location: {
        address: { street, city, state, postalCode, country },
      },
      canBeClaimed,
      certification,
      createdAt: businessCreatedAt,
    } = this.props.data.business;

    // claimer data
    const {
      id: claimerID,
      username,
      displayName,
      createdAt,
    } = this.props.data.claimer;

    return (
      <div>
        <CardHeader
          onClick={this.toggle}
          style={{ marginBottom: '1rem', cursor: 'pointer' }}>
          {parseDate(date)} - {city} - <b>{this.props.title}</b>{' '}
          <span style={{ color: this.state.claimStatusTitleTextColor }}>
            {this.state.claimStatusTitleText}
          </span>
        </CardHeader>
        <Collapse
          isOpen={this.state.collapse}
          style={{ position: 'relative', top: '-1.2rem' }}>
          <Card style={{ borderTop: '0px' }}>
            <CardBody>
              <div style={{ whiteSpace: 'pre-line' }}>
                <div className='business-claim'>
                  <div className='claim-details'>
                    <p>
                      <span>
                        <i class='fa fa-calendar' aria-hidden='true'></i> Claim
                        Submitted On:{' '}
                      </span>
                      {parseDate(date)}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-id-card' aria-hidden='true'></i> Claim
                        ID:{' '}
                      </span>
                      {claimID}
                    </p>
                    <hr />
                  </div>

                  <div className='business-details'>
                    <h3>Business Details</h3>
                    <p>
                      <span>
                        <i class='fa fa-id-card' aria-hidden='true'></i>{' '}
                        Business ID:
                      </span>
                      <br />
                      {businessID}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-building' aria-hidden='true'></i>{' '}
                        Business Name:
                      </span>
                      <br />
                      <b>{businessName}</b>
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-address-book-o' aria-hidden='true'></i>{' '}
                        Address:
                      </span>
                      <br />
                      <div className='address-container'>
                        <p>{street}</p>
                        <p>{city}</p>
                        <p>{state}</p>
                        <p>{postalCode}</p>
                        <p>{country}</p>
                      </div>
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-calendar' aria-hidden='true'></i>{' '}
                        Business created:
                      </span>
                      <br />
                      {parseDate(businessCreatedAt)}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-certificate' aria-hidden='true'></i>{' '}
                        Certification:
                      </span>
                      <br />
                      {certification}
                    </p>

                    <p>
                      <span>
                        <i class='fa fa-hand-paper-o' aria-hidden='true'></i>{' '}
                        Can Be Claimed:
                      </span>
                      <br />
                      {canBeClaimed ? 'Yes' : 'No'}
                    </p>
                    <p>
                      <a
                        rel='noopener noreferrer'
                        target='_blank'
                        href={`${APP_BASE_URL}/place/${slug}`}>
                        <Button color='primary'>Go To Business Page</Button>
                      </a>
                    </p>
                  </div>

                  <div className='user-details'>
                    <h3>Claimant Details</h3>
                    <p>
                      <span>
                        <i class='fa fa-id-card' aria-hidden='true'></i> Claimer
                        User ID:
                      </span>
                      <br />
                      {claimerID}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-user' aria-hidden='true'></i> Claimer
                        Display Name:
                      </span>
                      <br />
                      {displayName}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-user' aria-hidden='true'></i> Claimer
                        Username:
                      </span>
                      <br />
                      {username}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-calendar' aria-hidden='true'></i>{' '}
                        Account Created:
                      </span>
                      <br />
                      {parseDate(createdAt)}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-envelope-o' aria-hidden='true'></i>{' '}
                        Email:
                      </span>
                      <br />
                      {email}
                    </p>
                    <p>
                      <span>
                        <i class='fa fa-phone' aria-hidden='true'></i> Phone:
                      </span>
                      <br />
                      <p>
                        <NumberFormat
                          style={{ fontWeight: 'normal' }}
                          format='+1 (###) ###-####'
                          displayType={'text'}
                          type={'tel'}
                          value={phone}
                        />
                      </p>
                    </p>

                    <p>
                      <span>
                        <i class='fa fa-users' aria-hidden='true'></i>{' '}
                        Permission Group:
                      </span>
                      <br />
                      {permissionGroup}
                    </p>

                    <p>
                      <span>
                        <i class='fa fa-sticky-note' aria-hidden='true'></i>{' '}
                        User Notes:
                      </span>
                      <br />
                      <p>{note}</p>
                    </p>
                  </div>

                  {/* action buttons */}
                  <div className='form-actions' style={{ marginTop: 15 }}>
                    <Button
                      onClick={this.onApprove}
                      type='submit'
                      style={{ marginRight: 10 }}
                      color='primary'
                      disabled={
                        this.state.isApproving ||
                        this.state.isDenying ||
                        this.state.isArchiving
                      }>
                      {this.state.isApproving && (
                        <i
                          className='fa fa-circle-o-notch fa-spin'
                          style={{ marginRight: 5 }}
                        />
                      )}
                      Approve
                    </Button>
                    <Button
                      color='danger'
                      onClick={this.onDeny}
                      style={{ marginRight: 10 }}
                      disabled={
                        this.state.isApproving ||
                        this.state.isDenying ||
                        this.state.isArchiving
                      }>
                      {this.state.isDenying && (
                        <i
                          className='fa fa-circle-o-notch fa-spin'
                          style={{ marginRight: 5 }}
                        />
                      )}
                      Deny
                    </Button>
                    <Button
                      onClick={this.onArchive}
                      style={{ background: '#D1A52F', color: 'white' }}
                      disabled={
                        this.state.isApproving ||
                        this.state.isDenying ||
                        this.state.isArchiving
                      }>
                      {this.state.isArchiving && (
                        <i
                          className='fa fa-circle-o-notch fa-spin'
                          style={{ marginRight: 5 }}
                        />
                      )}
                      Archive
                    </Button>
                  </div>
                </div>
              </div>
              {/* ==============
                =================
                =========== */}
              {/* Submitted On: {parseDate(data.date)} <br />
                Business ID: {data.business.id} <br />
                Business Address:{' '}
                {GNAddressFormat(data.business.location.address)} <br /> <br />
                User Name:{' '}
                <a
                  rel='noopener noreferrer'
                  target='_blank'
                  href={`${APP_BASE_URL}/users/${data.claimer.username}`}>
                  {' '}
                  {data.claimer.displayName}{' '}
                </a>
                <br />
                User Phone: {data.data.phone} <br />
                User Email: {data.data.email} <br />
                User Note: <p>{data.data.note}</p> <br />
                Permission Group: {data.data.permissionGroup} <br /> <br />
                User Id: {data.claimer.id}
                <div className='form-actions' style={{ marginTop: 10 }}>
                  <Button
                    onClick={this.onApprove}
                    type='submit'
                    color='primary'
                    disabled={this.state.isApproving || this.state.isDenying}>
                    {this.state.isApproving && (
                      <i
                        className='fa fa-circle-o-notch fa-spin'
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Approve
                  </Button>
                  <Button
                    color='danger'
                    onClick={this.onDeny}
                    disabled={this.state.isApproving || this.state.isDenying}>
                    {this.state.isDenying && (
                      <i
                        className='fa fa-circle-o-notch fa-spin'
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Deny
                  </Button>
                </div>
              </div> */}
            </CardBody>
          </Card>
        </Collapse>
      </div>
    );
  }
}

DropdownCard.defaultProps = {
  title: 'New Business Claim',
};



// WEBPACK FOOTER //
// ./src/components/DropdownCardNew.js